module.exports = __webpack_public_path__ + "assets/icons/ic_merge-4846.svg";